// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Util_Opt = require("../../util/Util_Opt.bs.js");
var Belt_Array = require("@rescript/std/lib/js/belt_Array.js");
var Util_Array = require("../../util/Util_Array.bs.js");
var Belt_Option = require("@rescript/std/lib/js/belt_Option.js");
var Belt_SortArray = require("@rescript/std/lib/js/belt_SortArray.js");

function getUrl(width, imageResolution) {
  var resolutions = Belt_SortArray.stableSortBy(imageResolution, (function (r1, r2) {
          if (r1.w > r2.w) {
            return 1;
          } else {
            return 0;
          }
        }));
  var getHighestResolution = function (param) {
    return Belt_Option.mapWithDefault(Util_Array.getLastElement(resolutions), "", (function (param) {
                  return param.url;
                }));
  };
  return Util_Opt.mapWithDefaultLazy(Belt_Array.getBy(resolutions, (function (resolution) {
                    return resolution.w >= width;
                  })), getHighestResolution, (function (param) {
                return param.url;
              }));
}

function itemTemplateToImageStyle(itemTemplate) {
  switch (itemTemplate) {
    case /* Banner */0 :
        return /* Banner */1;
    case /* Newsletter */9 :
        return /* EventZone */6;
    case /* ContentCollection */1 :
    case /* PageHeader */10 :
        return /* ThumbnailLandscape */16;
    case /* Guide */3 :
    case /* Landscape */5 :
    case /* LandscapeGenre */8 :
    case /* Partner */11 :
    case /* PlayNext */12 :
        return /* StandardTeaser */15;
    case /* Portrait */13 :
        return /* PortraitTeaser */10;
    case /* Poster */14 :
        return /* PosterTeaser */11;
    case /* EbuBox */2 :
    case /* Label */4 :
    case /* ProgramContent */15 :
        return ;
    case /* Square */16 :
        return /* Square */14;
    case /* LandscapeBig */6 :
    case /* LandscapeBigWithSubtitle */7 :
    case /* TextOnLeftSide */17 :
    case /* TextOnRightSide */18 :
        return /* BigTeaser */3;
    
  }
}

exports.getUrl = getUrl;
exports.itemTemplateToImageStyle = itemTemplateToImageStyle;
/* No side effect */
